'use strict';
module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/is-pure.js
// module id = 41
// module chunks = 13